// PasswordValidator.jsx
//import React from "react";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import "./PasswordValidator.css";

function PasswordValidator({ password }) {
  const rules = [
    {
      label: "Minimum 8 characters",
      isValid: password.length >= 8,
    },
    {
      label: "At least one uppercase letter",
      isValid: /[A-Z]/.test(password),
    },
    {
      label: "At least one lowercase letter",
      isValid: /[a-z]/.test(password),
    },
    {
      label: "At least one number",
      isValid: /[0-9]/.test(password),
    },
    {
      label: "At least one special character",
      isValid: /[^A-Za-z0-9]/.test(password),
    },
  ];

   

  return (
    <div className="password-validator">
      {rules.map((rule, index) => (
        <div key={index} className="rule-row">

{rule.isValid ? (
  <FaCheckCircle className="icon-valid" />
) : (
  <FaTimesCircle className="icon-invalid" />
)}


          <span className={rule.isValid ? "valid-text" : "invalid-text"}>
            {rule.label}
          </span>
        </div>
      ))}
    </div>
  );
}

export default PasswordValidator;

